import {useTheme} from '../Tools/Themes';
import React, {Component} from 'react';
import {Text, Linking, ScrollView} from 'react-native';
import styled, {css} from 'styled-components/native';
import {colours, spacing} from '../styles/Style';
import {GetGlobalTheme, IsHRWeb} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import Requests from '../api/Requests';
import LanguageSelect from '../components/status/LanguageSelect';
import {Dimensions} from 'react-native';

const LoginWrap = styled.View`
  ${(IsHRWeb() &&
    css`
      position: relative;
      height: 100vh;
    `) ||
  css`
    height: 100%;
    justify-content: center;
  `}
  width: 100%;
  background-color: ${colours[GetGlobalTheme()].mainBackground};
`;
const ForgotWrap = styled.TouchableOpacity``;

const LoginForm = styled.View`
  margin: 0 auto;
  ${(IsHRWeb() &&
    css`
      position: absolute;
      width: 300px;
      top: 50%;
      margin-top: -170px;
      left: 50%;
      margin-left: -150px;
    `) ||
  css`
    max-width: ${Dimensions.get('window').width > 400
      ? '400px'
      : Dimensions.get('window').width};
    width: 100%;
    height: 440px;
    position: absolute;
    top: 50%;
    margin-top: -220px;
    left: 50%;
    margin-left: -${Dimensions.get('window').width > 400 ? '200px' : Dimensions.get('window').width / 2};
  `}
  padding: 20px;
  background: ${colours[GetGlobalTheme()].navigationBackground};
  border-radius: 6px;
`;

export class LoginWindow extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.LoginUser = this.LoginUser.bind(this);
    this.onKeyPressUserName = this.onKeyPressUserName.bind(this);
    this.onKeyPressPassword = this.onKeyPressPassword.bind(this);
    this.passwordref = React.createRef();
    this.state = {
      ID: '',
      Password: '',
      icon: 'eye-slash',
      secure: true,
    };
    if (IsHRWeb()) {
      document.title = translate('LoginPage');
    }
  }

  LoginUser = () => {
    Requests.TestLogin(this.state.ID, this.state.Password)
      .then((response) => {
        global.setUserDetails = {
          username: this.state.ID,
          password: this.state.Password,
        };
        global.refreshScreen(true);
      })
      .catch((error) => {});
  };
  onKeyPressUserName = () => {
    this.passwordref.current.focus();
  };

  onKeyPressPassword = () => {
    let self = this;
    setTimeout(function () {
      self.LoginUser();
    }, 500);
  };

  render() {
    let self = this;
    return (
      <LoginWrap>
        <LoginForm>
          <ScrollView
            contentContainerStyle={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <EditField
              title={translate('EmailPersCode')}
              value={this.state.ID}
              width="100%"
              name={'username'}
              onSubmitEditing={() => this.onKeyPressUserName()}
              inputStyle={{
                backgroundColor: colours[GetGlobalTheme()].inputBackground,
              }}
              onChange={(index, fn, value) => {
                self.setState({ID: value});
              }}
              onChangeText={(value) => {
                self.state.ID = value;
              }}
            />
            <EditField
              title={translate('Password')}
              width="100%"
              value={this.state.Password}
              secure={this.state.secure}
              icon={this.state.icon}
              reference={this.passwordref}
              onSubmitEditing={() => this.onKeyPressPassword()}
              iconClick={() => {
                if (self.state.secure) {
                  self.setState({icon: 'eye', secure: false});
                } else {
                  self.setState({icon: 'eye-slash', secure: true});
                }
              }}
              inputStyle={{
                backgroundColor: colours[GetGlobalTheme()].inputBackground,
                paddingHorizontal: 10,
              }}
              onChange={(index, fn, value) => self.setState({Password: value})}
              onChangeText={(value) => {
                self.state.Password = value;
              }}
            />
            <ActionButton
              onPress={() => {
                self.LoginUser();
              }}
              style={{width: IsHRWeb() ? null : '96%'}}
              title={translate('Login')}
            />
            <ActionButton
              onPress={() => global.updateLoginStatus(4)}
              style={{width: IsHRWeb() ? null : '96%'}}
              title={translate('Register')}
            />
            <ForgotWrap onPress={(e) => global.updateLoginStatus(4)}>
              <Text
                style={{
                  color: colours[GetGlobalTheme()].inputLabelText,
                  marginTop: 10,
                }}
              >
                {translate('ForgotPassword')}
              </Text>
            </ForgotWrap>
            <LanguageSelect style={{marginTop: spacing.large}} />
          </ScrollView>
        </LoginForm>
      </LoginWrap>
    );
  }
}
